import '../../../scss/critical.scss';
import '../../../scss/index.scss';
import '../../../scss/content_hub.scss';
import '../../../scss/creator-studio-hero.scss';
import '../../../scss/help.scss';

const $ = require('jquery');
global.$ = global.jQuery = $;

$(document).ready(function () {
    import(
        /* webpackMode: "lazy" */
        '../qg-main'
    ).then(function () {});
});
